import { createFileRoute } from "@tanstack/react-router";
import { Section, SectionHeader } from "@/components/Section";
import { CTASection } from "@/components/CTASection";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Reveal";
import { TEAM } from "@/lib/team";
import { SITE } from "@/lib/site";
import { seoTitle, seoDescription } from "@/lib/seo-meta";

const TITLE = seoTitle("Equipe Técnica — Dedetizadora em Chapecó/SC");
const DESC = seoDescription(
  "Conheça a equipe técnica da Dedetizadora em Chapecó: responsável técnico, aplicadores certificados e atendimento especializado em controle de pragas urbanas.",
);

export const Route = createFileRoute("/equipe")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "/equipe" },
    ],
    links: [{ rel: "canonical", href: `${SITE.baseUrl}/equipe` }],
  }),
  component: Equipe,
});

function Equipe() {
  return (
    <>
      <section className="hero-bg">
        <div className="container-svg pt-12 pb-12 md:pt-20 md:pb-16">
          <Breadcrumbs items={[{ label: "Início", to: "/" }, { label: "Equipe" }]} />
          <div className="mt-6 max-w-3xl">
            <span className="eyebrow">Equipe técnica</span>
            <h1 className="mt-4 text-4xl font-bold tracking-tight md:text-5xl">
              Quem executa o controle de pragas na sua casa ou empresa
            </h1>
            <p className="mt-5 text-base text-muted-foreground md:text-lg">
              Equipe multidisciplinar: responsável técnico habilitado, aplicadores treinados e atendimento dedicado. Cada serviço tem um profissional identificado e certificado ao final.
            </p>
          </div>
        </div>
      </section>

      <Section>
        <SectionHeader
          eyebrow="A equipe"
          title="Profissionais responsáveis pelo seu atendimento"
          description="Todos com treinamento em manejo integrado de pragas, uso de EPI e produtos registrados."
        />
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {TEAM.map((m, i) => (
            <Reveal key={m.name} delay={((i % 4) + 1) as 1 | 2 | 3 | 4}>
              <article className="card-glass flex h-full flex-col items-center text-center">
                {m.photo ? (
                  <img
                    src={m.photo}
                    alt={`Foto de ${m.name}`}
                    loading="lazy"
                    width={96}
                    height={96}
                    className="h-24 w-24 rounded object-cover border-2 border-primary"
                  />
                ) : (
                  <div aria-hidden className="flex h-24 w-24 items-center justify-center rounded text-2xl font-bold text-primary bg-accent border-2 border-primary">{m.initials}</div>
                )}
                <h3 className="mt-5 text-lg font-semibold">{m.name}</h3>
                <p className="mt-1 text-xs uppercase tracking-wider font-semibold text-primary">{m.role}</p>
                <p className="mt-3 text-sm text-muted-foreground">{m.bio}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </Section>

      <CTASection title="Fale com nossa equipe agora" text="Vistoria técnica gratuita em Chapecó e região. Orçamento rápido pelo WhatsApp." buttonLabel="Chamar no WhatsApp" />
    </>
  );
}
